import styled from "styled-components";

export const generateInputs = <T extends "number" | "string" = "number">(
  inputAmount: number,
  returnType: T = "number" as T
): T extends "number" ? number[] : string[] => {
  return Array(inputAmount)
    .fill(0)
    .map((_, i) => (returnType === "number" ? i : "")) as T extends "number"
    ? number[]
    : string[];
};

const SmsInputS = styled.input<{ isUdv?: boolean; isRegister?: boolean }>`
  ${({ isUdv, isRegister }) =>
    isUdv
      ? `max-width: 66px;
    height: 64px;`
      : `max-width: 94px;
    height: 88px;`};
  border: none;
  border-radius: 12px;
  background: #f3f3f7;
  outline: none;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 28px;
  :focus {
    border-color: #27ae60;
    ::placeholder {
      opacity: 0;
    }
  }
  @media (max-width: 600px) {
    ${({ isUdv }) =>
      isUdv
        ? `max-width: 48px;
    height: 48px;`
        : `max-width: 64px;
      height: 64px;;`};
  }

  /* &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    appearance: none;
    margin: 0;
  } */
`;

const Wrapper = styled.div<{
  isValid?: boolean;
  isUdv?: boolean;
  isRegister?: boolean;
}>`
  display: flex;
  ${({ isUdv }) => (isUdv ? `gap: 8px;` : `gap: 20px;`)}
  ${({ isValid }) =>
    isValid &&
    `input {
    border-color: green;
  }`}
`;

export const SmsInput = ({ onChange, isUdv, id }: any) => {
  return (
    <SmsInputS
      onChange={onChange}
      maxLength={1}
      placeholder="0"
      isUdv={isUdv}
      // type="number"
      pattern="[0-9]*"
      inputMode="numeric"
      id={id}
    />
  );
};

export const SmsContainer = ({
  inputChange,
  isValid,
  inputAmount,
  isUdv = false,
  isRegister = false,
}: any) => {
  const Inputs = generateInputs(inputAmount);

  return (
    <Wrapper isValid={isValid} isUdv={isUdv} isRegister={isRegister}>
      {Inputs.map((item) => {
        return (
          <SmsInput
            key={item}
            onChange={(e) => {
              inputChange(e, item);
            }}
            isUdv={isUdv}
            isRegister={isRegister}
            id={`otp-${item}`}
          />
        );
      })}
    </Wrapper>
  );
};
